import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Link, useNavigate } from 'react-router-dom';
import { useTranslation } from '../context/I18nContext';
import { Button } from '../components/ui/Button';
import { Input } from '../components/ui/Input';
import { Card, CardContent } from '../components/ui/Card';
import supabase from '../supabase/supabase';

export const Login = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  const [isSignUp, setIsSignUp] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError('');
    
    const email = e.target.email.value;
    const password = e.target.password.value;

    try {
      if (isSignUp) {
        const { error: signUpError } = await supabase.auth.signUp({ email, password });
        if (signUpError) throw signUpError;
        alert('Check your email for the confirmation link!');
      } else {
        const { error: signInError } = await supabase.auth.signInWithPassword({ email, password });
        if (signInError) throw signInError;
        navigate('/dashboard');
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="min-h-[calc(100vh-64px)] flex items-center justify-center p-6 bg-zinc-50">
      <motion.div initial={{ opacity: 0, scale: 0.95 }} animate={{ opacity: 1, scale: 1 }} className="w-full max-w-md">
        <Card className="border-0 shadow-xl">
          <div className="p-8 text-center pb-6">
            <div className="w-12 h-12 bg-zinc-900 rounded-xl flex items-center justify-center mx-auto mb-6">
              <span className="text-white text-2xl font-black">f</span>
            </div>
            <h2 className="text-2xl font-bold text-zinc-900">
              {isSignUp ? 'Create Supplier Account' : t('auth.loginTitle')}
            </h2>
            <p className="text-sm text-zinc-500 mt-2">
              {isSignUp ? 'Join our network of premium producers' : t('auth.loginSubtitle')}
            </p>
          </div>
          <CardContent>
            <form onSubmit={handleSubmit} className="space-y-4">
              {error && <div className="p-3 text-sm text-red-500 bg-red-50 rounded-lg border border-red-100">{error}</div>}
              <Input id="email" type="email" label={t('auth.email')} placeholder="chef@restaurant.com" required />
              <Input id="password" type="password" label={t('auth.password')} placeholder="••••••••" required />
              <Button type="submit" fullWidth disabled={isLoading}>
                {isLoading ? t('common.loading') : (isSignUp ? 'Register' : t('auth.loginButton'))}
              </Button>
            </form>
            <div className="mt-6 text-center text-sm">
              <button onClick={() => setIsSignUp(!isSignUp)} className="text-zinc-500 hover:text-zinc-900 transition-colors">
                {isSignUp ? 'Already have an account? Sign in' : "Don't have an account? Sign up"}
              </button>
            </div>
          </CardContent>
        </Card>
      </motion.div>
    </div>
  );
};